
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1s55x_vsddp_145",
  "label": "awsui_label_1s55x_vsddp_149",
  "label-top": "awsui_label-top_1s55x_vsddp_163",
  "stud": "awsui_stud_1s55x_vsddp_168"
};
  